module.exports = __webpack_public_path__ + "img/cartoon_haibei.36f13f00.png";